// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RBT2AsAc_yzfgsmMW5Uq{width:100%;flex-shrink:1}.RBT2AsAc_yzfgsmMW5Uq>svg{width:100%}.gY5x_KfzCgC3dN_kfj19{display:flex;flex-direction:row;justify-content:flex-start;align-items:center;gap:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"defaultIconClass": "RBT2AsAc_yzfgsmMW5Uq",
	"iconContainer": "gY5x_KfzCgC3dN_kfj19"
};
export default ___CSS_LOADER_EXPORT___;
